import React, { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Space } from '@g2u/ui-kit';
import { useNavigate } from 'react-router-dom';

import { RootStore } from 'store';

import { type JsonDataItem, type WithOptionalDataTest } from 'types';

export namespace Actions {
  export type Props = {
    job: JsonDataItem | null;
    isDisabled?: boolean;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { job, isDisabled } = props;
    const { setJob } = RootStore;
    const navigate = useNavigate();

    return (
      <Space.$ direction={Space.Direction.Horizontal} size={Space.Size.Small} justify={Space.Justify.End}>
        <Button.$
          dataTestId="open-job-tickets"
          onClick={() => {
            setJob(job);
            navigate(`/tasks/tickets?search_value=${job?.ID}&search_type=service_id`);
          }}
          disabled={!job || isDisabled }
        >
          Open Tickets
        </Button.$>
      </Space.$>
    );
  });
}
